<template>
  <div>
    <section class="container-fluid p-0">
      <slot />
    </section>
  </div>
</template>
<script>
export default {};
</script>
